import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	taskOneDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.teams-concept-step.task-one-description-non-final',
		defaultMessage: `You can build your own on-call teams and optimize alerting and on-call settings for your team's purpose and way of working.\n
What you can do with on-call teams:\n
- assign teams as a responder to alerts
- create on-call schedules for teams
- build team-based policies, integrations, automation, maintenance, and more.\n
The team admins can manage operations for the team while others can only respond to alerts.
`,
		description: 'Transition home teams concept task one description / markdown',
	},
	taskOneCtaNonFinal: {
		id: 'eoc-changeboarding.transition-home.teams-concept-step.task-one-cta-non-final',
		defaultMessage: 'Read how to launch operations for your team',
		description: 'Transition home alerts step task one call to action',
	},
	taskTwoDescriptionNonFinal: {
		id: 'eoc-changeboarding.transition-home.teams-concept-step.task-two-description-non-final',
		defaultMessage: `All the teams from Opsgenie have been synced as Atlassian teams, so they'll now be visible on all products on your Atlassian site.\n
Just so you know, only team members with a Jira Service Management license can use alerting and on-call.\n
To browse your teams, select **Teams > Search people and teams** from Jira navigation. On the team’s profile page, select **Go to operations** to access alerting and on-call features.
`,
		description: 'Transition home teams concept task one description / markdown',
	},
	tableDescriptionTextNonFinal: {
		id: 'eoc-changeboarding.transition-home.teams-concept-step.table-description-text-non-final',
		defaultMessage: "Here are some of the teams you're a member of:",
		description:
			'The descriptive text above the teams table, shows how many team user is member of',
	},
});
